import { useTranslation } from 'react-i18next';
import Guide from '../../components/guide/Guide';

const GuideIndexPage = () => {
	const { t } = useTranslation();
	document.title = `${t('general.app_name')} Ai`;

	return (
		<div className='flex flex-col justify-center items-center gap-8 p-8'>
			<div className='flex flex-col items-center gap-[10px]  max-w-2xl'>
				<h1 className='text-[38px] text-on-secondary text-center'>
					{t('guide_page.title', { app_name: t('general.app_name') })}
				</h1>
				<p className='text-on-tertiary-active text-center'>
					{t('guide_page.subtext', { app_name: t('general.app_name') })}
				</p>
			</div>
			<Guide />
		</div>
	);
};

export default GuideIndexPage;
